<div class="mt-6 w-full flex flex-col gap-5">
  <p-toast></p-toast>
  <p-confirmdialog />
  <p-card>
    <ng-template #title>
      <h1>{{ 'catalog.additionalProducts.title' | translate }}</h1>
    </ng-template>

    <div class="flex justify-end gap-2 mb-5">
      <p-button
        icon="fa fa-plus"
        [label]="'catalog.additionalProducts.add' | translate"
        (onClick)="navigateToCreate()"
      />
    </div>

    <p-table
      [value]="service.items()"
      stripedRows
      showGridlines
      dataKey="id"
      [paginator]="true"
      [rows]="25"
      [rowsPerPageOptions]="[25, 50, 75, 100]"
      sortField="title"
      [sortOrder]="1"
      [scrollable]="true"
      [tableStyle]="{ 'min-width': '40rem' }"
    >
      <ng-template #header>
        <tr>
          <th pSortableColumn="title">
            {{ 'catalog.additionalProducts.fields.title' | translate }}
            <p-sortIcon field="title" />
          </th>
          <th>{{ 'catalog.additionalProducts.fields.type' | translate }}</th>
          <th class="text-right">
            {{ 'catalog.prices.current' | translate }}
          </th>
          <th pFrozenColumn alignFrozen="right" class="w-32"></th>
        </tr>
      </ng-template>
      <ng-template #body let-row>
        <tr class="cursor-pointer" (click)="navigateToDetail(row)">
          <td>{{ row.title }}</td>
          <td>
            <p-tag
              severity="info"
              [value]="
                'catalog.additionalProducts.types.' + row.type | translate
              "
            />
          </td>
          <td class="text-right">{{ formatCurrentPrice(row) }}</td>
          <td pFrozenColumn alignFrozen="right">
            <div class="flex items-center justify-end gap-2">
              <button
                pButton
                type="button"
                icon="fa fa-pencil"
                text
                rounded
                severity="secondary"
                (click)="navigateToDetail(row); $event.stopPropagation()"
              ></button>
              <button
                pButton
                type="button"
                icon="fa fa-trash"
                text
                rounded
                severity="secondary"
                (click)="onRowDelete($event, row); $event.stopPropagation()"
              ></button>
            </div>
          </td>
        </tr>
      </ng-template>
      <ng-template #emptymessage>
        <tr>
          <td colspan="4" class="text-center italic text-color-secondary py-6">
            {{ 'catalog.additionalProducts.empty' | translate }}
          </td>
        </tr>
      </ng-template>
    </p-table>
  </p-card>
</div>
